module.exports = __webpack_public_path__ + "static/media/inyrmind.1ba61111.svg";